import React from "react";

export const ContactInfoTab = () => (
  <div className="space-y-4"></div>
);
